import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DocumentoUICamViewModel } from '../../unidad-inspeccion-datosbasicos.types';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { ListBase } from 'src/app/components/core/_infrastructure/classes/listBase';
import { proxiedPropertiesOf } from 'src/app/components/core/_infrastructure/types/utils';
import { Table } from 'primeng/table';
import { Mixin } from 'ts-mixer';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';

@Component({
    selector: 'app-documento-ui-list',
    templateUrl: './documento-ui-list.component.html',
    styleUrls: ['./documento-ui-list.component.scss'],
})
export class DocumentoUiListComponent extends Mixin(ListBase, ComponentBase) implements OnInit, OnChanges {
    @Input() result: DocumentoUICamViewModel[];
    @Input() title: { plural: string; singular: string };
    @Input() hasDeletingAccess: boolean;
    @Input() hasViewingAccess: boolean;
    @Input() idUsuario = undefined;
    @Output() delete = new EventEmitter<number>();
    @Output() view = new EventEmitter<number>();

    isCollapsedCabecera = false;
    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];

    constructor(
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.initCols();
        this.loading = false;
    }

    private initCols(): void {
        const inspeccionUI = proxiedPropertiesOf<DocumentoUICamViewModel>();

        this.cols = [
            { field: 'Link', header: '', reduce: true },
            { field: 'Image', header: '', reduce: true },
            { field: inspeccionUI.Id, header: 'Id', display: 'none' },
            { field: inspeccionUI.FechaCreacion, header: 'F. Creación' },
            { field: inspeccionUI.Descripcion, header: 'Descripción' },
            { field: inspeccionUI.NombreArchivo, header: 'Nombre Doc.' },
            { field: inspeccionUI.Usuario, header: 'Usuario' },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            this.result = [...changes.result.currentValue];
            this.loading = false;
            setTimeout(() => {
                if (this.turboTable) {
                    this.turboTable.first = 1 * this.result?.length;
                }
            }, 100);
        }
    }

    onDelete(item: DocumentoUICamViewModel): void {
        this.delete.emit(item.Id);
    }

    onView(item: DocumentoUICamViewModel): void {
        this.view.emit(item.Id);
    }

    canBeDeleted(item: DocumentoUICamViewModel): boolean {
        return this.hasDeletingAccess && (this.isAdmin || item.IdUsuario === this.idUsuario);
    }
}
